import { render, staticRenderFns } from "./SelectColumn.vue?vue&type=template&id=26c0e6b8&"
import script from "./SelectColumn.vue?vue&type=script&lang=js&"
export * from "./SelectColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports